import React from 'react';
import {assignInlineVars} from '@vanilla-extract/dynamic';
import cx from 'classnames';

import {theme} from '#theme';

import {UncertainProgressProps} from './UncertainProgress.types';

import {
  backgroundColorVar,
  delayVar,
  dotSizeVar,
  dotStyles,
  durationVar,
  rootStyles,
  widthVar,
} from './UncertainProgress.css';

export const UncertainProgress: React.FC<UncertainProgressProps> = ({
  width = 400,
  size = 30,
  duration = 2,
  className,
}) => {
  return (
    <div
      className={cx(rootStyles, className)}
      style={assignInlineVars({[widthVar]: `${width}px`, [dotSizeVar]: `${size}px`})}>
      <div
        className={dotStyles}
        style={assignInlineVars({
          [delayVar]: `1s`,
          [dotSizeVar]: `${size}px`,
          [durationVar]: `${duration}s`,
          [backgroundColorVar]: theme.colors.grapefruit,
        })}
      />
      <div
        className={dotStyles}
        style={assignInlineVars({
          [delayVar]: `0.75s`,
          [dotSizeVar]: `${size}px`,
          [durationVar]: `${duration}s`,
          [backgroundColorVar]: theme.colors.peach,
        })}
      />
      <div
        className={dotStyles}
        style={assignInlineVars({
          [delayVar]: `0.5s`,
          [dotSizeVar]: `${size}px`,
          [durationVar]: `${duration}s`,
          [backgroundColorVar]: theme.colors.apricot,
        })}
      />
      <div
        className={dotStyles}
        style={assignInlineVars({
          [delayVar]: `0.25s`,
          [dotSizeVar]: `${size}px`,
          [durationVar]: `${duration}s`,
          [backgroundColorVar]: theme.colors.pink,
        })}
      />
      <div
        className={dotStyles}
        style={assignInlineVars({
          [delayVar]: `0s`,
          [dotSizeVar]: `${size}px`,
          [durationVar]: `${duration}s`,
          [backgroundColorVar]: theme.colors.burgundy,
        })}
      />
    </div>
  );
};
